module.exports = __webpack_public_path__ + "static/media/0_2019_04_15.bde82dab.jpg";